import { __exports as MSI } from "./index208.js";
import { __require as requireBarcode } from "./index158.js";
var hasRequiredMSI;
function requireMSI() {
  if (hasRequiredMSI) return MSI;
  hasRequiredMSI = 1;
  Object.defineProperty(MSI, "__esModule", {
    value: true
  });
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var MSI$1 = (function(_Barcode) {
    _inherits(MSI2, _Barcode);
    function MSI2(data, options) {
      _classCallCheck(this, MSI2);
      return _possibleConstructorReturn(this, (MSI2.__proto__ || Object.getPrototypeOf(MSI2)).call(this, data, options));
    }
    _createClass(MSI2, [{
      key: "encode",
      value: function encode() {
        var ret = "110";
        for (var i = 0; i < this.data.length; i++) {
          var digit = parseInt(this.data[i]);
          var bin = digit.toString(2);
          bin = addZeroes(bin, 4 - bin.length);
          for (var b = 0; b < bin.length; b++) {
            ret += bin[b] == "0" ? "100" : "110";
          }
        }
        ret += "1001";
        return {
          data: ret,
          text: this.text
        };
      }
    }, {
      key: "valid",
      value: function valid() {
        return this.data.search(/^[0-9]+$/) !== -1;
      }
    }]);
    return MSI2;
  })(_Barcode3.default);
  function addZeroes(number, n) {
    for (var i = 0; i < n; i++) {
      number = "0" + number;
    }
    return number;
  }
  MSI.default = MSI$1;
  return MSI;
}
export {
  requireMSI as __require
};
//# sourceMappingURL=index175.js.map
